import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SnippetsTwoToneSvg from "@ant-design/icons-svg/es/asn/SnippetsTwoTone";
import AntdIcon from '../components/AntdIcon';
var SnippetsTwoTone = function SnippetsTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: SnippetsTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(SnippetsTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'SnippetsTwoTone';
}
export default RefIcon;